import { lazy, Suspense } from 'react'

const DatePicker = lazy(async () => {
  await import('react-datepicker/dist/react-datepicker.css')
  const m = await import('react-datepicker')
  return { default: m.default }
})

export function LazyDatePicker(props) {
  return (
    <Suspense
      fallback={
        <input
          type="text"
          readOnly
          disabled
          className={props.className}
          placeholder={props.placeholderText}
          aria-busy="true"
        />
      }
    >
      <DatePicker {...props} />
    </Suspense>
  )
}
